import SectionSubGroup from "@components/SectionGroup/SectionSubGroup"
import ShopIcon from "@components/ShopIcon/ShopIcon"
import Localization from "@localization/Index"
import { useMobileMediaQuery } from "@utils/MediaComponents"
import { getOrderStatus } from "@utils/OrderUtils"
import { getUserShops } from "@utils/ShopsUtils"
import { Order, Shop } from "cs.node.utils/csapi/provisioning"
import { numberFormatCurrency } from "cs.node.utils/NumbersUtils"
import { format, parseISO } from "date-fns"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"

type Props = {
    order: Order
}

const HeaderSearchBarResultOrder = (props: Props) => {
    const { order } = props
    const [shops, setShops] = useState<Shop[]>()
    const navigate = useNavigate()
    const isMobile = useMobileMediaQuery()

    const init = async()=>{
        try{
            const shops = await getUserShops()
            setShops(shops)
        } catch (error) {
            setShops(undefined)
        }
    }

    useEffect(()=>{
        init()
    },[])

    const shop = shops?.find(element=>element._id?.$oid === order?.shop_id?.$oid)
    const status = getOrderStatus(order?.order_status)
    const statusLabel = order?.order_status?`${order.order_status.substring(0, 1).toUpperCase()}${order.order_status.substring(1).toLowerCase()}`:"N.D."

    const date = (!!order?.order_dt?.$date)?format(parseISO(order?.order_dt?.$date), 'dd/MM/yyyy'):"N.D."
    const time = (!!order?.order_dt?.$date)?format(parseISO(order?.order_dt?.$date), 'HH:mm'):undefined

    const currency = order?.tot_amount?.currency ?? "EUR"
    const amountLabel = numberFormatCurrency(order?.tot_amount?.amount ?? 0, currency)

    if(isMobile) {
        return <div className="row my-2 py-4 w-100" style={{borderBottom: '1px dashed var(--bs-gray-gray-300'}} onClick={(e)=>{
            const link = `/orders/${order._id?.$oid}`
            
            if(e?.metaKey || e?.ctrlKey) {
                window.open(link, "_blank");
            } else{
                navigate(link)
            }
        }}>
            <div className="col-10 d-flex align-items-center justify-content-start">
                <span className="d-flex align-items-center justify-content-center bg-secondary p-2" style={{borderRadius: '50%', width: '30px', height: '30px'}}>
                    <ShopIcon id={shop?.cs_shop_id?.$oid ?? ""} size={16} />
                </span>
                <div className="d-flex flex-column align-items-start justify-content-center ms-4">
                    <div className="fw-bolder small cs-link">{order?.shop_order_id}</div>
                    <div className="fw-normal small mt-1">{shop?.name}</div>
                </div>
            </div>
            <div className="col-14 d-flex flex-column align-items-end justify-content-center">
                <span className={`badge fw-600 bg-${status.color}-light text-${status.color}`}>{statusLabel}</span>
                <div className="text-muted small mt-1">{`${date} ${time}`}</div>
            </div>
        </div>
    }


    return <SectionSubGroup small className="w-100" role="button" onClick={(e)=>{
            const link = `/orders/${order._id?.$oid}`
            
            if(e?.metaKey || e?.ctrlKey) {
                window.open(link, "_blank");
            } else{
                navigate(link)
            }
        }}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center justify-content-start">
                <span className="d-flex align-items-center justify-content-center bg-secondary p-2" style={{borderRadius: '50%', width: '30px', height: '30px'}}>
                    <ShopIcon id={shop?.cs_shop_id?.$oid ?? ""} size={16} />
                </span>
                <div className="d-flex flex-column align-items-start justify-content-center ms-4">
                    <div className="fw-bolder small cs-link">{order?.shop_order_id}</div>
                    <div className="fw-normal small">{shop?.name}</div>
                </div>
            </div>
            <div className="d-flex flex-column align-items-start justify-content-center">
                <div className="fw-bolder small">{order?.buyer_name}</div>
                <div className="fw-normal small">{Localization.PAGE_ORDERS.TABLE.CLIENTE}</div>
            </div>
            <span className={`badge fw-600 bg-${status.color}-light text-${status.color}`}>{statusLabel}</span>
            <div className="d-flex flex-column align-items-start justify-content-start">
                <div className="fw-bold small">{date}</div>
                <div className="fw-normal small">{time}</div>
            </div>
            <div className="d-flex flex-column align-items-end justify-content-center">
                <div className="fw-bolder small">{order?.tot_qty ?? 0}</div>
                <div className="fw-normal small">{Localization.PAGE_ORDERS.TABLE.NUMERO_ARTICOLI}</div>
            </div>
            <div className="d-flex flex-column align-items-end justify-content-center">
                <div className="fw-bolder small">{amountLabel}</div>
                <div className="fw-normal small">{Localization.PAGE_ORDERS.TABLE.CONTROVALORE}</div>
            </div>
        </div>
    </SectionSubGroup>
}

export default HeaderSearchBarResultOrder